module.exports = __webpack_public_path__ + "static/media/campaign-feature-2.af2883f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/campaign-feature-2.png
// module id = 611
// module chunks = 0